module.exports = __webpack_public_path__ + "img/publicusericon.021af16f.png";